<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px', fullScreenBackdrop: true }"></ngx-loading>

<ng-container *ngIf="!embedded; else setupContent">
  <main class="main-site-wrap wrapper">
    <app-header></app-header>
    <div class="site-content-wrap position-relative">
      <app-sidebar></app-sidebar>
      <div class="page-wrapper darkthird-bg">
        <div class="page-content">
          <profile-top-outer
            [currentDetail]="currentDetail"
            [imgURL]="imgURL"
            [editable]="true"
            [creatorTypes]="currentDetail?.creator_types || []"
          ></profile-top-outer>
          <div class="profile-info-outer profile-height-vh">
            <div class="row">
              <div class="col-12 col-xl-11">
                <div class="tab-wrap">
                  <profile-pills-tab [loginDetail]="loginDetail"></profile-pills-tab>
                  <div class="tab-content">
                    <ng-container *ngTemplateOutlet="setupContent"></ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </main>
</ng-container>

<ng-template #setupContent>
  <div class="bank-setup-page" [class.is-embedded]="embedded">
    <div class="bank-setup-layout">
      <section class="bank-setup-card">
        <header class="bank-setup-header">
          <div class="bank-setup-title-row">
            <h1 class="bank-setup-title">Bank Account Setup</h1>
            <span class="bank-setup-info-icon"
              matTooltip="The platform will not hold or store your bank data. Payouts are handled securely through Stripe."
              matTooltipPosition="above" aria-label="More information">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.2" />
                <path d="M8 7.2V11.2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
                <circle cx="8" cy="5" r="0.8" fill="currentColor" />
              </svg>
            </span>
          </div>
          <p class="bank-setup-subtitle">
            To receive payouts, select your country and connect your Stripe account. This will set your default
            currency.
          </p>
        </header>

        <div class="bank-setup-step">
          <h2 class="bank-setup-step-title">1. Select Country &amp; Currency</h2>

          <div class="bank-setup-fields">
            <label class="bank-setup-label" for="countryCurrency">Country &amp; Currency</label>

            <div class="bank-setup-select" [class.is-open]="dropdownOpen" [class.is-locked]="isStripeLinked">
              <button type="button" id="countryCurrency" class="bank-setup-select-trigger"
                (click)="toggleDropdown(); $event.stopPropagation()" [attr.aria-expanded]="dropdownOpen"
                [disabled]="isStripeLinked">
                <ng-container *ngIf="!selectedCountry; else selectedTpl">
                  <span class="bank-setup-globe" aria-hidden="true">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5" />
                      <path d="M3 12h18M12 3c2.5 2.5 3.8 5.5 3.8 9s-1.3 6.5-3.8 9c-2.5-2.5-3.8-5.5-3.8-9s1.3-6.5 3.8-9z"
                        stroke="currentColor" stroke-width="1.5" />
                    </svg>
                  </span>
                  <span class="bank-setup-placeholder">Select Country</span>
                </ng-container>
                <ng-template #selectedTpl>
                  <img class="bank-setup-flag" [src]="flagUrl(selectedCountry.code)" [alt]="selectedCountry.name"
                    width="24" height="18" />
                  <span class="bank-setup-selected-text">
                    <strong>{{ selectedCountry.name }}</strong>
                    <span class="bank-setup-currency-meta">
                      {{ selectedCountry.currency }} - {{ currencyLabel(selectedCountry.currency) }}
                    </span>
                  </span>
                </ng-template>
                <span class="bank-setup-chevron" aria-hidden="true">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </span>
              </button>

              <div class="bank-setup-dropdown" *ngIf="dropdownOpen" (click)="$event.stopPropagation()">
                <div class="bank-setup-search-wrap">
                  <span class="bank-setup-search-icon" aria-hidden="true">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.6"/>
                      <path d="M16.5 16.5L21 21" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                    </svg>
                  </span>
                  <input
                    type="text"
                    class="bank-setup-search"
                    placeholder="Search country..."
                    [(ngModel)]="searchTerm"
                    (click)="$event.stopPropagation()"
                  />
                </div>
                <ul class="bank-setup-options">
                  <li *ngFor="let country of filteredCountries" class="bank-setup-option"
                    [class.is-active]="selectedCountryId === country._id" (click)="selectCountry(country)">
                    <img class="bank-setup-flag" [src]="flagUrl(country.code)" [alt]="country.name" width="24"
                      height="18" />
                    <span>
                      <strong>{{ country.name }}</strong>
                      <span class="bank-setup-currency-meta">
                        {{ country.currency }} - {{ currencyLabel(country.currency) }}
                      </span>
                    </span>
                  </li>
                  <li class="bank-setup-option empty" *ngIf="filteredCountries.length === 0">
                    No countries found
                  </li>
                </ul>
              </div>
            </div>

            <div class="bank-setup-alert alert-idle" *ngIf="alertState === 'idle'">
              <span class="bank-setup-alert-icon" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="1.5" y="1.5" width="13" height="13" rx="3" stroke="currentColor" stroke-width="1.2" />
                  <path d="M8 7.2V11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
                  <circle cx="8" cy="5.2" r="0.75" fill="currentColor" />
                </svg>
              </span>
              <p>Select your country to check whether Stripe payouts are currently supported.</p>
            </div>

            <div class="bank-setup-alert alert-supported" *ngIf="alertState === 'supported'">
              <span class="bank-setup-alert-icon" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="1.5" y="1.5" width="13" height="13" rx="3" stroke="currentColor" stroke-width="1.2" />
                  <path d="M8 7.2V11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
                  <circle cx="8" cy="5.2" r="0.75" fill="currentColor" />
                </svg>
              </span>
              <div>
                <p class="alert-title">{{ selectedCountry?.name }} is supported for payouts.</p>
                <p>You're ready to connect your Stripe account.</p>
              </div>
            </div>

            <div class="bank-setup-alert alert-linked" *ngIf="alertState === 'linked'">
              <span class="bank-setup-alert-icon check" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="9" cy="9" r="8" stroke="currentColor" stroke-width="1.4" />
                  <path d="M5.5 9.2L8 11.7L12.5 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </span>
              <p>Your Stripe account is now linked to receive payouts.</p>
            </div>

            <div class="bank-setup-alert alert-unsupported" *ngIf="alertState === 'unsupported'">
              <span class="bank-setup-alert-icon warn" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="1.5" y="1.5" width="13" height="13" rx="3" stroke="currentColor" stroke-width="1.2" />
                  <path d="M8 4.5V8.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                  <circle cx="8" cy="11" r="0.8" fill="currentColor" />
                </svg>
              </span>
              <div>
                <p class="alert-title">Payouts in alternate currencies are not supported at this time.</p>
                <p>Currently, only Australia (AUD) payouts are supported. Please select Australia to connect your Stripe
                  account.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="bank-setup-actions">
          <button type="button" class="bank-setup-stripe-btn" (click)="connectStripe()"
            [disabled]="!canConnectStripe" [class.is-disabled]="!canConnectStripe"
            aria-label="Connect with Stripe">
            <svg class="stripe-logo" xmlns="http://www.w3.org/2000/svg" viewBox="54 36 360 150" width="48" height="20"
              role="img" aria-hidden="true">
              <title>Stripe</title>
              <g fill="#635BFF" fill-rule="evenodd" clip-rule="evenodd">
                <path
                  d="M414 113.4c0-25.6-12.4-45.8-36.1-45.8-23.8 0-38.2 20.2-38.2 45.6 0 30.1 17 45.3 41.4 45.3 11.9 0 20.9-2.7 27.7-6.5v-20c-6.8 3.4-14.6 5.5-24.5 5.5-9.7 0-18.3-3.4-19.4-15.2h48.9c.2-4.6.4-9.8.4-12.2zm-49.4-9.5c0-11.3 6.9-16 13.2-16 6.1 0 12.6 4.7 12.6 16h-25.8z" />
                <path
                  d="M301.1 67.6c-9.8 0-16.1 4.6-19.6 7.8l-1.3-6.2h-22v116.6l25-5.3.1-28.3c3.6 2.6 8.9 6.3 17.7 6.3 17.9 0 34.2-14.4 34.2-46.1-.1-28.4-16.6-44.2-34.1-44.2zm-6 68.9c-5.9 0-9.4-2.1-11.8-4.7l-.1-37.1c2.6-2.9 6.2-4.9 11.9-4.9 9.1 0 15.4 10.2 15.4 23.3 0 16.9-6.2 26.9-15.4 26.9z" />
                <polygon points="223.8,61.7 248.9,56.3 248.9,36 223.8,41.3" />
                <rect x="223.8" y="69.3" width="25.1" height="87.5" />
                <path
                  d="M196.9 76.7l-1.6-7.4h-21.6v87.5h25V97.5c5.9-7.7 15.9-6.3 19-5.2v-23c-3.2-1.2-14.9-3.4-20.8 7.4z" />
                <path
                  d="M146.9 47.6l-24.4 5.2-.1 80.1c0 14.8 11.1 25.7 25.9 25.7 8.2 0 14.2-1.5 17.5-3.3V135c-3.2 1.3-19 5.9-19-8.9V90.6h19V69.3h-19l.1-21.7z" />
                <path
                  d="M79.3 94.7c0-3.9 3.2-5.4 8.5-5.4 7.6 0 17.2 2.3 24.8 6.4V72.2c-8.3-3.3-16.5-4.6-24.8-4.6C67.5 67.6 54 78.2 54 95.9c0 27.6 38 23.2 38 35.1 0 4.6-4 6.1-9.6 6.1-8.3 0-18.9-3.4-27.3-8v23.8c9.3 4 18.7 5.7 27.3 5.7 20.8 0 35.1-10.3 35.1-28.2.1-24.8-37.9-19.5-37.9-35.7z" />
              </g>
            </svg>
          </button>
          <button type="button" class="bank-setup-manage-btn" (click)="manageStripe()"
            [disabled]="!isStripeLinked" [class.is-disabled]="!isStripeLinked">
            Manage Stripe Account
          </button>
        </div>

        <p class="bank-setup-secure">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true">
            <rect x="2" y="5" width="8" height="6" rx="1.2" stroke="currentColor" stroke-width="1.1" />
            <path d="M4 5V3.8a2 2 0 0 1 4 0V5" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" />
          </svg>
          Secure &amp; powered by Stripe.
        </p>
      </section>

      <aside class="bank-setup-aside">
        <h3>Not seeing your country?</h3>
        <p>We're working on adding more countries and currencies soon.</p>
      </aside>
    </div>
  </div>
</ng-template>

<div class="bank-setup-backdrop" *ngIf="dropdownOpen" (click)="closeDropdown()"></div>